var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchBrand"},_vm._l((_vm.washProductBrandList),function(item,index){return _c('div',{key:index,staticClass:"brand-item",on:{"click":function($event){return _vm.onBrand(item)}}},[_vm._v("\n        "+_vm._s(item.brandName)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }